Promise.prototype.tryResolve = tryResolve;

async function mockAsync(){
    return 0;
}

async function appendPromiseTryResoleve(){
    var e = mockAsync()
    e.constructor.prototype.tryResolve = tryResolve;
}

appendPromiseTryResoleve();

function tryResolve(this: any, errorValue) {
    return new Promise((resolve, reject) => {
        this.then(data => resolve(data)).catch(error => resolve(errorValue))
    })
}